/* eslint-disable no-restricted-imports */
// FSD VIOLATION: Layout component that composes upload widget and weave feature.
// Moving to widgets would break features that import it.
import { UploadArtwork } from "@design-lab/widgets/design-lab-upload-artwork";
import { FrontBackSubTabs } from "./FrontBackSubTabs";

export function UploadSection() {
  return (
    <FrontBackSubTabs
      title="Upload"
      number={1}
      testIdPrefix="upload"
      frontContent={<UploadArtwork side="front" />}
      backContent={<UploadArtwork side="back" />}
    />
  );
}
